import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { verifyTokenValidity } from "../../write/application/use-cases/token-verification/verify-token-validity";
import { selectTokenValidityCheck } from "@user-management-context/write/application/use-cases/token-verification/selectors/token-validity-selectors";
import { generateMessage } from "../shared/account-creation";
import { AccountActivationFormContainer } from "./account-activation-form.container";

interface Props {
  userId: string;
  token: string;
}

export const AccountActivationContainer = ({ userId, token }: Props) => {
  const dispatch = useAppDispatch();

  const { data: tokenFromDB } = useAppSelector(selectTokenValidityCheck);
  const tokenStatus = tokenFromDB?.status ?? "valid";
  const user = tokenFromDB?.user ?? null;

  useEffect(() => {
    dispatch(verifyTokenValidity({ userId, token }));
  }, [dispatch, token, userId]);

  if (tokenStatus !== "valid") return generateMessage(tokenStatus);
  // Formulaire monté une fois l'invité connu : ses champs partent de son identité
  if (!user) return null;

  return <AccountActivationFormContainer user={user} userId={userId} token={token} />;
};
